<template>
    <b-modal :visible="visible" title="Убрать сотрудника из табеля" centered scrollable content-class="argus-glass-dialog"
        :no-close-on-backdrop="pending" :no-close-on-esc="pending" :hide-header-close="pending"
        @change="$emit('input', $event)" @hide="preventPendingClose">
        <p><EmployeeLink v-if="line" :employee-id="line.employee_id" :fallback="line.employee_name_snapshot" open-in-panel /></p>
        <p v-if="removed" role="status">Сотрудник убран из табеля.</p>
        <p v-else>Строка и её несохранённые правки будут убраны только из этого табеля. Вернуть сотрудника можно через «Добавить сотрудника».</p>
        <b-form-group label="Причина" label-for="timesheet-exclusion-reason">
            <b-form-select id="timesheet-exclusion-reason" v-model="reasonCode" :options="reasons" :disabled="pending || removed" />
        </b-form-group>
        <b-form-group label="Своя причина или дополнение" label-for="timesheet-exclusion-text">
            <DiscussionEditor id="timesheet-exclusion-text" v-model="reasonText" :disabled="pending || removed" :maxlength="2000" />
            <small class="text-muted">Причина сохранится в истории.
                <template v-if="line && line.exclusion_has_assignment">В этом месяце сотрудник был назначен на объект — запись также появится в его характеристиках.</template>
            </small>
        </b-form-group>
        <template #modal-footer>
            <div class="timesheet-exclusion-footer">
                <b-form-checkbox v-if="line && line.exclusion_has_assessment" v-model="discardAssessments" :disabled="pending || removed" class="mb-2">
                    <template v-if="line.shared_characteristic && line.shared_characteristic.id">Подтверждаю удаление КТУ и его обоснования вместе со строкой. Общая характеристика сохранится.</template>
                    <template v-else>Подтверждаю удаление КТУ, оснований КТУ и характеристики вместе со строкой. При возврате они не восстановятся.</template>
                </b-form-checkbox>
                <div v-if="error" role="alert" class="alert alert-danger py-2 mb-2">{{ error }}</div>
                <div class="d-flex justify-content-end flex-wrap">
                    <b-button variant="outline-secondary" :disabled="pending" @click="$emit('input', false)">{{ removed ? 'Закрыть' : 'Отмена' }}</b-button>
                    <b-button :variant="removed ? 'primary' : 'danger'" class="ml-2" :disabled="pending || (!removed && !valid)" @click="submit">
                        <b-spinner v-if="pending" small /> {{ removed ? 'Обновить табель' : 'Убрать из табеля' }}
                    </b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
import EmployeeLink from '@/components/EmployeeLink.vue';
export default {
    components: {EmployeeLink},
    props: {visible: Boolean, line: {type: Object, default: null}, pending: Boolean, removed: Boolean, error: {type: String, default: ''}},
    model: {prop: 'visible', event: 'input'},
    data: () => ({reasonCode: '', reasonText: '', discardAssessments: false, reasons: [
        {value: '', text: 'Выберите причину или напишите свою'},
        {value: 'not_arrived', text: 'Не приехал'}, {value: 'added_by_mistake', text: 'Ошибочно добавлен'},
        {value: 'no_work_this_month', text: 'Не работал на объекте в этом месяце'}, {value: 'left_object', text: 'Выбыл с объекта'}
    ]}),
    computed: {valid() { return Boolean((this.reasonCode || this.reasonText.trim())
        && (!this.line || !this.line.exclusion_has_assessment || this.discardAssessments)); }},
    watch: {visible(value) { if (value) { this.reasonCode = ''; this.reasonText = ''; this.discardAssessments = false; } }},
    methods: {
        preventPendingClose(event) { if (this.pending) event.preventDefault(); },
        submit() { if ((this.removed || this.valid) && !this.pending) this.$emit('submit', {reason_code: this.reasonCode || null,
            reason_text: this.reasonText.trim(), discard_assessments: this.discardAssessments}); }
    }
};
</script>

<style scoped>
.timesheet-exclusion-footer { width: 100%; min-width: 0; overflow-wrap: anywhere; }
</style>
